<!-- edit-report-hunt-package.component.html -->
<ng-container *ngIf="loaded(); else loading">
  <hyperkit-typography variant="h5" align="left" color="primary">
    {{ packageView.title() }}
  </hyperkit-typography>

  <hyperkit-tab-bar variant="secondary" mode="underline" [controlled]="true">
    <hyperkit-tab
      text="Overview"
      [selected]="subtab() === 'overview'"
      (click)="setSubtab('overview')"
    ></hyperkit-tab>
    <hyperkit-tab
      text="Queries & Notes"
      [selected]="subtab() === 'queryNotes'"
      (click)="setSubtab('queryNotes')"
    ></hyperkit-tab>
  </hyperkit-tab-bar>

  <div class="tab-panel-content">
    <!-- Overview tab -->
    <ng-container *ngIf="subtab() === 'overview'">
      <hunt-details-editor
        title="Threat Description"
        [value]="packageView.description()"
        (valueChange)="onDescriptionChange($event)"
      ></hunt-details-editor>

      <hunt-details-editor
        title="Mitigation Recommendations"
        [value]="packageView.mitigationRecommendations()"
        (valueChange)="onMitigationRecommendationsChange($event)"
      ></hunt-details-editor>
    </ng-container>

    <!-- Queries & Notes tab -->
    <ng-container *ngIf="subtab() === 'queryNotes'">
      <div class="query-container">
        <div class="env-header">
          <hyperkit-typography variant="h5" align="left" color="primary">
            Environments
          </hyperkit-typography>
          <hyperkit-tag
            mode="outline"
            [text]="packageView.getNumEnvironments().toString()"
          ></hyperkit-tag>
        </div>
      </div>

      <hyperkit-accordion
        *ngFor="let env of envs()"
        [title]="env.name"
        [expanded]="true"
      >
        <ng-template #headerTemplate>
          <div class="env-header-template">
            <div class="env-name">
              <hyperkit-typography
                variant="emphasized"
                size="sm"
                color="primary"
              >
                {{ env.name }}
              </hyperkit-typography>
            </div>
          </div>
        </ng-template>

        <div>
          <hyperkit-accordion
            *ngFor="let tool of env.tools"
            [title]="tool.name"
            [expanded]="true"
          >
            <ng-template #headerTemplate>
              <div class="tool-header-template">
                <div class="tool-info">
                  <img width="20px" [src]="getToolIcon(tool.product)" />
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    color="primary"
                  >
                    {{ tool.name }}
                  </hyperkit-typography>
                </div>
                <hyperkit-tag
                  mode="outline"
                  [text]="(tool.generatedContent?.Hunt?.length || 0).toString()"
                ></hyperkit-tag>
              </div>
            </ng-template>

            <div>
              <div
                class="content-container"
                *ngFor="let content of tool.generatedContent?.Hunt || []"
              >
                <hyperkit-report-query-header
                  [isPivot]="false"
                  [category]="content.category"
                  [numPivots]="content.pivots?.length || 0"
                ></hyperkit-report-query-header>

                <hyperkit-code-block
                  [code]="content.query"
                ></hyperkit-code-block>

                <report-text-block
                  *ngIf="content.notes"
                  title="Notes"
                  variant="body"
                  size="lg"
                  [value]="content.notes"
                ></report-text-block>

                <ng-container *ngFor="let pivot of content.pivots">
                  <report-pivot-block
                    [pivot]="pivot"
                    [parentCategory]="content.category"
                  ></report-pivot-block>
                </ng-container>
              </div>
            </div>
          </hyperkit-accordion>
        </div>
      </hyperkit-accordion>
    </ng-container>
  </div>
</ng-container>
<ng-template #loading>
  <p>Loading…</p>
</ng-template>
